import isValueEmpty from '../../isValueEmpty';

export const errorMessage = __(
  'This field is too long (max: %{maxLength} characters)',
);

export const validateMaxLength = (value, maxLength) => {
  let error;

  if (isValueEmpty(value)) {
    return error;
  }

  if (value.length > maxLength) {
    error = errorMessage.i__({
      maxLength,
    });
  }

  return error;
};
